// Wave 6a (founder, 26 Sep): English counterpart of golf6App.nl.ts. Apple and Google button names
// are written the way an English device shows them ("Add to Home Screen", "Add", "Install app").
export const appGolf6En = {
    tabletGuide: {
        title: 'How to connect an iPad to the board',
        intro: 'Three steps, about a minute. Keep this page open.',
        step1Title: 'Open Safari on the iPad',
        step1Body: 'Type this address in the address bar:',
        copy: 'Copy',
        copied: 'Copied',
        copyLabel: 'Copy the address {url}',
        step2Title: 'The board shows a code',
        step2Body: 'Eight characters, like ABCD-2345. Leave the iPad as it is.',
        step3Title: 'Enter the code here',
        step3Body: 'Also pick the room where the board hangs. The board appears within a few seconds.',
        enterCode: 'Enter code',
        orTitle: 'Rather not type?',
        orBody: 'Create a QR code and scan it with the iPad’s camera. The board connects itself.',
        qrButton: 'Connect with a QR code',
        tipsTitle: 'Tips for a board on the wall',
        tips: [
            {
                title: 'Put the board on the Home Screen',
                body: 'Then the board opens full screen, without an address bar. Do this before connecting: an app on the Home Screen has its own memory and is connected separately.',
            },
            {
                title: 'Auto-Lock: Never',
                body: 'Settings › Display & Brightness › Auto-Lock › Never. Keep the iPad on its charger and the screen stays on.',
            },
            {
                title: 'Guided Access',
                body: 'Settings › Accessibility › Guided Access (older iPad with iOS 12: Settings › General › Accessibility › Guided Access): turn it on and choose a passcode. Open the board and quickly press the Home button (or the top button) three times. Children then stay in the board.',
            },
            {
                title: 'Tap once for sound',
                body: 'An iPad only plays sound after a tap. Tap the board once after it starts, and you’ll hear the adhan and the calls.',
            },
        ],
        homeScreenHow: 'How do I put it on the Home Screen?',
    },
    qr: {
        title: 'Connect with a QR code',
        intro: 'The iPad scans the code with its camera and connects itself. No typing needed.',
        room: 'Room',
        name: 'Tablet name',
        defaultName: 'iPad {room}',
        create: 'Create QR code',
        scanTitle: 'Scan with the iPad’s camera',
        scanSteps: [
            'Open the Camera app on the iPad.',
            'Point it at this code until a notification appears at the top.',
            'Tap the notification. The board opens in Safari and connects itself.',
        ],
        validFor: 'Valid for {time} · works once',
        qrLabel: 'QR code to connect a tablet in {room}',
        waiting: 'Waiting for the iPad to scan…',
        claimed: '{name} is connected',
        claimedBody: 'The board in {room} now shows the calendar.',
        expired: 'This QR code has expired',
        expiredBody: 'A QR code works for 10 minutes and only once. Create a new one.',
        again: 'New QR code',
        done: 'Done',
        safariNote: 'The QR code opens the board in Safari. Is the board already on the Home Screen? Then connect that app with the code.',
        keepPrivate: 'Don’t show this code to others: whoever scans it gets your family’s board.',
    },
    phoneQr: {
        title: 'Open AMUMIN on your phone',
        body: 'Scan this code with your phone’s camera. Then add AMUMIN to your Home Screen.',
        label: 'QR code to {url}',
    },
    install: {
        platform: 'Which device?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        thisDevice: '{platform} (this device)',
        iosSteps: [
            'Open {url} in Safari.',
            'Tap Share: the square with the arrow pointing up. On an iPhone it’s at the bottom, on an iPad at the top next to the address. Can’t see it? Tap ··· first.',
            'Swipe or scroll in the share menu until you see Add to Home Screen, then tap it. On an older iPad it’s in the bottom row: swipe that row to the left.',
            'Tap Add in the top right.',
            'From now on, open {app} with the icon on your Home Screen.',
        ],
        androidSteps: [
            'Open {url} in Chrome.',
            'Tap the three dots in the top right.',
            'Choose Install app (or Add to Home screen).',
            'Tap Install. {app} is now among your apps.',
        ],
        desktopSteps: [
            'Open {url} in Chrome or Edge.',
            'Click the install icon on the right of the address bar (a small screen with an arrow).',
            'Click Install. {app} now opens in its own window.',
        ],
        ui: {
            share: 'Share',
            addToHome: 'Add to Home Screen',
            add: 'Add',
            cancel: 'Cancel',
            installApp: 'Install app',
            install: 'Install',
        },
        pictureLabel: 'Example of step {n}',
    },
    stepUp: {
        which: 'Enter your own AMUMIN password: the one you use to sign in at {host}.',
        notThese: 'So not the Wi-Fi password and not the iPad’s passcode.',
        why: 'We ask for this at important steps, such as connecting a tablet. After that you won’t be asked again for 10 minutes.',
        account: 'Your account',
        password: 'Your AMUMIN password',
        forgot: 'Forgot your password?',
    },
    tasks: {
        forWho: 'Who is it for?',
        forWhoHint: 'The children are already selected. Tap a name to add or remove someone.',
        nobody: 'Choose at least one person.',
    },
    werklijstDoc: {
        read: 'Read the advice',
        readLabel: 'Read the advice: {title}',
        loading: 'Loading the advice…',
        missing: 'This advice isn’t in this version of the app yet.',
        error: 'The advice can’t be read right now. Please try again later.',
        back: 'Back',
        external: '(opens in a new window)',
    },
};
//# sourceMappingURL=golf6App.en.js.map